import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from "@/components/ui/button";
import { Box, Heading, Text, VStack } from "@chakra-ui/react";

const Home: React.FC = () => {
  return (
    <Box maxWidth="container.md" margin="auto" padding={8}>
      <VStack spacing={6} align="stretch">
        <Heading as="h1" size="2xl">Mileage Report Generator</Heading>
        <Text fontSize="xl">Generate detailed mileage reports for tax deduction purposes</Text>
        <Link to="/report/new">
          <Button size="lg">Generate New Report</Button>
        </Link>
      </VStack>
    </Box>
  );
};

export default Home;